import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '../src/assets/commun.css'
import axios from 'axios'
import { read, utils } from "xlsx"

   
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.$axios = axios

router.beforeEach((to, from, next)=>{
   if(to.meta.content) {     //路由发生变化时候修改meta中的content
      let head = document.getElementByTagName('head')
      let meta = document.createElemnet('meta')
      document.querySelector('meta[name="keywords"]').setAttribute('content',to.meta.content.keywords)
      document.querySelector('meta[name="description"]').setAttribute('content',to.meta.content.description)
      meta.content = to.meta.content
      dead[0].appendChild(meta)
      
   }
   if(to.meta.title) {   //路由发生变化时候修改页面中的title
       document.title = to.meta.title
   }
   next()
})


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
